import React, { memo } from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import { Contact } from '@lgg/isomorphic/types/__generated__/graphql';
import { FlexRow } from 'src/components/layout/flex-row';
import { ContactItem } from 'src/components/pages/contacts/components/contact-item';

const EmptyContactList = styled(FlexRow)`
  align-items: center;
  background-color: ${({ theme }) => theme.colors.white};
  color: ${({ theme }) => theme.colors.storm};
  font-size: 13px;
  height: 38px;
  letter-spacing: 0;
  padding: 0 20px;
`;

type ContactListProps = {
  contacts: Contact[];
};

export const ContactList = memo<ContactListProps>(({ contacts }) => {
  const { t } = useTranslation(['common']);

  return (
    <>
      {contacts?.length > 0 ? (
        contacts.map((contact) => <ContactItem key={contact.id} contact={contact} />)
      ) : (
        <EmptyContactList>{t('common:noResults')}</EmptyContactList>
      )}
    </>
  );
});
